import Imunizacao from '../pages/Imunizacao/Index'
import VacinaIdadeCerta from '../pages/Imunizacao/VacinaIdadeCerta/Index'
import FaltososVacinas0a15anos from '../pages/Imunizacao/VacinaIdadeCerta/FaltososVacinas0a15anos/Index'
import FaltososVacinas0a15anosPorEquipeAcs from '../pages/Imunizacao/VacinaIdadeCerta/FaltososVacinas0a15anos/PorEquipeAcs'
import FaltososVacinas0a15anosPorProfissional from '../pages/Imunizacao/VacinaIdadeCerta/FaltososVacinas0a15anos/PorProfissional'

import HpvQuadrivalente from '../pages/Imunizacao/VacinaIdadeCerta/HpvQuadrivalente/Index.vue'
import HpvQuadrivalentePorEquipeAcs from '../pages/Imunizacao/VacinaIdadeCerta/HpvQuadrivalente/PorEquipeAcs'

import Acwy from '../pages/Imunizacao/VacinaIdadeCerta/Acwy/Index'
import AcwyPorEquipeAcs from '../pages/Imunizacao/VacinaIdadeCerta/Acwy/PorEquipeAcs'

import TripliceViral from '../pages/Imunizacao/VacinaIdadeCerta/TripliceViral/Index'
import TripliceViralPorEquipeAcs from '../pages/Imunizacao/VacinaIdadeCerta/TripliceViral/PorEquipeAcs'

import Varicela from '../pages/Imunizacao/VacinaIdadeCerta/Varicela/Index.vue'
import VaricelaPorEquipeAcs from '../pages/Imunizacao/VacinaIdadeCerta/Varicela/PorEquipeAcs'

import Covid19Infantil from '@/pages/Imunizacao/VacinaIdadeCerta/Covid19Infantil/Index.vue'
import Covid19InfantilPorEquipeAcs from '@/pages/Imunizacao/VacinaIdadeCerta/Covid19Infantil/PorEquipeAcs'

import TetraViral from '../pages/Imunizacao/VacinaIdadeCerta/TetraViral/Index.vue'
import TetraViralPorEquipeAcs from '../pages/Imunizacao/VacinaIdadeCerta/TetraViral/PorEquipeAcs'

import VacinaDengue from '@/pages/Imunizacao/VacinaIdadeCerta/VacinaDengue/Index.vue'
import VacinaDenguePorEquipeAcs from '@/pages/Imunizacao/VacinaIdadeCerta/VacinaDengue/PorEquipeAcs'

export default [
  {
    path: '/imunizacao',
    component: Imunizacao,
  },
  {
    path: '/vacina-idade-certa',
    component: VacinaIdadeCerta,
  },
  {
    path: '/divergencias-vacinas',
    component: () => import('@/pages/Imunizacao/DivergenciasVacinas/Index.vue'),
  },
  {
    path: '/importar-vacinas',
    component: () => import('@/pages/Imunizacao/ImportarVacinas/Index.vue'),
  },
  {
    path: '/divergencias-vacinas/vacinas-nao-enviadas',
    component: () =>
      import(
        '@/pages/Imunizacao/DivergenciasVacinas/VacinasNaoEnviadas/Template.vue'
      ),
    children: [
      {
        path: '/divergencias-vacinas/vacinas-nao-enviadas/equipe/acs',
        component: () =>
          import(
            '@/pages/Imunizacao/DivergenciasVacinas/VacinasNaoEnviadas/PorEquipeAcs.vue'
          ),
      },
    ],
  },
  {
    path: '/d3-antes-6',
    component: () =>
      import('@/pages/Imunizacao/DivergenciasVacinas/D3Antes6/Template.vue'),
    children: [
      {
        path: '/divergencias-vacinas/d3-antes-6/equipe/acs',
        component: () =>
          import(
            '@/pages/Imunizacao/DivergenciasVacinas/D3Antes6/PorEquipeAcs.vue'
          ),
      },
    ],
  },
  {
    path: '/vacinas-nascimento-divergente',
    component: () =>
      import(
        '@/pages/Imunizacao/DivergenciasVacinas/VacinasNascimentoDivergente/Template.vue'
      ),
    children: [
      {
        path: '/divergencias-vacinas/vacinas-nascimento-divergente/equipe/acs',
        component: () =>
          import(
            '@/pages/Imunizacao/DivergenciasVacinas/VacinasNascimentoDivergente/PorEquipeAcs.vue'
          ),
      },
    ],
  },
  {
    path: '/vacinas-sem-cadastro',
    component: () =>
      import(
        '@/pages/Imunizacao/DivergenciasVacinas/VacinasSemCadastro/Template.vue'
      ),
    children: [
      {
        path: '/divergencias-vacinas/vacinas-sem-cadastro/equipe/acs',
        component: () =>
          import(
            '@/pages/Imunizacao/DivergenciasVacinas/VacinasSemCadastro/PorEquipeAcs.vue'
          ),
      },
    ],
  },
  {
    path: '/vacinas-antes-nascimento',
    component: () =>
      import(
        '@/pages/Imunizacao/DivergenciasVacinas/VacinasAntesNascimento/Template.vue'
      ),
    children: [
      {
        path: '/divergencias-vacinas/vacinas-antes-nascimento/equipe/acs',
        component: () =>
          import(
            '@/pages/Imunizacao/DivergenciasVacinas/VacinasAntesNascimento/PorEquipeAcs.vue'
          ),
      },
    ],
  },
  {
    path: '/faltosos-vacinas-0-15-anos',
    component: () =>
      import(
        '@/pages/Imunizacao/VacinaIdadeCerta/FaltososVacinas0a15anos/Template.vue'
      ),
    children: [
      {
        path: '/faltosos-vacinas-0-15-anos',
        component: FaltososVacinas0a15anos,
      },
      {
        path: '/faltosos-vacinas-0-15-anos/equipe/acs',
        component: FaltososVacinas0a15anosPorEquipeAcs,
      },
      {
        path: '/faltosos-vacinas-0-15-anos/profissional',
        component: FaltososVacinas0a15anosPorProfissional,
      },
    ],
  },
  {
    path: '/hpv-quadrivalente',
    component: () =>
      import(
        '@/pages/Imunizacao/VacinaIdadeCerta/HpvQuadrivalente/Template.vue'
      ),
    children: [
      {
        path: '/hpv-quadrivalente',
        component: HpvQuadrivalente,
      },
      {
        path: '/hpv-quadrivalente/equipe/acs',
        component: HpvQuadrivalentePorEquipeAcs,
      },
    ],
  },
  {
    path: '/acwy',
    component: () =>
      import('@/pages/Imunizacao/VacinaIdadeCerta/Acwy/Template.vue'),
    children: [
      {
        path: '/acwy',
        component: Acwy,
      },
      {
        path: '/acwy/equipe/acs',
        component: AcwyPorEquipeAcs,
      },
    ],
  },
  {
    path: '/covid19-infantil',
    component: () =>
      import(
        '@/pages/Imunizacao/VacinaIdadeCerta/Covid19Infantil/Template.vue'
      ),
    children: [
      {
        path: '/covid19-infantil',
        component: Covid19Infantil,
      },
      {
        path: '/covid19-infantil/equipe/acs',
        component: Covid19InfantilPorEquipeAcs,
      },
    ],
  },
  {
    path: '/vacina-dengue',
    component: () =>
      import('@/pages/Imunizacao/VacinaIdadeCerta/VacinaDengue/Template.vue'),
    children: [
      {
        path: '/vacina-dengue',
        component: VacinaDengue,
      },
      {
        path: '/vacina-dengue/equipe/acs',
        component: VacinaDenguePorEquipeAcs,
      },
    ],
  },
  {
    path: '/campanha-gripe',
    component: () => import('@/pages/Imunizacao/CampanhaGripe/Template.vue'),
    children: [
      {
        path: '/campanha-gripe',
        component: () => import('@/pages/Imunizacao/CampanhaGripe/Index.vue'),
      },
      {
        path: '/campanha-gripe/equipe',
        component: () =>
          import('@/pages/Imunizacao/CampanhaGripe/PorEquipe.vue'),
      },
    ],
  },
  {
    path: '/criancas-dtp-em-atraso',
    component: () =>
      import(
        '@/pages/Imunizacao/VacinaIdadeCerta/CriancasComDtpEmAtraso/Template.vue'
      ),
    children: [
      {
        path: '/criancas-dtp-em-atraso',
        component: () =>
          import(
            '@/pages/Imunizacao/VacinaIdadeCerta/CriancasComDtpEmAtraso/Index.vue'
          ),
      },
      {
        path: '/criancas-dtp-em-atraso/equipe/acs',
        component: () =>
          import(
            '@/pages/Imunizacao/VacinaIdadeCerta/CriancasComDtpEmAtraso/PorEquipeAcs.vue'
          ),
      },
    ],
  },
  {
    path: '/pneumococica-10v',
    component: () =>
      import(
        '@/pages/Imunizacao/VacinaIdadeCerta/Pneumococica10V/Template.vue'
      ),
    children: [
      {
        path: '/pneumococica-10v',
        component: () =>
          import(
            '@/pages/Imunizacao/VacinaIdadeCerta/Pneumococica10V/Index.vue'
          ),
      },
      {
        path: '/pneumococica-10v/equipe/acs',
        component: () =>
          import(
            '@/pages/Imunizacao/VacinaIdadeCerta/Pneumococica10V/PorEquipeAcs.vue'
          ),
      },
    ],
  },
  {
    path: '/triplice-viral',
    component: () =>
      import('@/pages/Imunizacao/VacinaIdadeCerta/TripliceViral/Template.vue'),
    children: [
      {
        path: '/triplice-viral',
        component: TripliceViral,
      },
      {
        path: '/triplice-viral/equipe/acs',
        component: TripliceViralPorEquipeAcs,
      },
    ],
  },
  {
    path: '/varicela',
    component: () =>
      import('@/pages/Imunizacao/VacinaIdadeCerta/Varicela/Template.vue'),
    children: [
      {
        path: '/varicela',
        component: Varicela,
      },
      {
        path: '/varicela/equipe/acs',
        component: VaricelaPorEquipeAcs,
      },
    ],
  },
  {
    path: '/dose-imunizante',
    component: () => import('@/pages/Imunizacao/DoseImunizante/Template.vue'),
    children: [
      {
        path: '/dose-imunizante',
        component: () => import('@/pages/Imunizacao/DoseImunizante/Index.vue'),
      },
      {
        path: '/dose-imunizante/equipe/acs',
        component: () =>
          import('@/pages/Imunizacao/DoseImunizante/PorEquipeAcs.vue'),
      },
    ],
  },
  {
    path: '/tetra-viral',
    component: () =>
      import('@/pages/Imunizacao/VacinaIdadeCerta/TetraViral/Template.vue'),
    children: [
      {
        path: '/tetra-viral',
        component: TetraViral,
      },
      {
        path: '/tetra-viral/equipe/acs',
        component: TetraViralPorEquipeAcs,
      },
    ],
  },
]
